<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createProvider()"
                >
                  <span>&#10003;</span>Set Rate Provider
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Exchange Rates
                    <!-- <span v-if="baseCurrency">(Base Currency: {{ baseCurrency }})</span> -->
                    <span><i class="ic-transfer-money"></i></span>
                  </h2>
                  <p>Manage your base currency and foreign exchange rates.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div>
          <div class="table-header" v-if="isAllowToRead">
            <div class="row text-center">
              <div class="form-group mbz">
                <div class="btn-group btn-group-toggle mb-15" data-toggle="buttons">
                  <label
                    class="btn"
                    :class="{
                      active: filteredProvider === item.id,
                    }"
                    v-for="(item, index) in rateProviders"
                    :key="index"
                    @click="onClickRateProvider(item)"
                  >
                    <input
                      type="radio"
                      name="title"
                      autocomplete="off"
                      :id="index"
                      :value="item.id"
                      v-model="filteredProvider"
                    />{{ item.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="number">No</th>
                  <!-- <th class="hidden">Mode</th> -->
                  <th class="text-center">Currency</th>
                  <th class="text-right">Sell</th>
                  <th class="text-right">Buy</th>
                  <th class="text-right">Mid</th>
                  <th class="text-center">Percentage?</th>
                  <th class="text-right">Offset Sell</th>
                  <th class="text-right">Offset Buy</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in items" :key="item.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <!-- <td class="hidden">{{ item.provider }}</td> -->
                  <td class="text-center">{{ item.currency }}</td>
                  <td class="text-right">{{ item.sell }}</td>
                  <td class="text-right">{{ item.buy }}</td>
                  <td class="text-right">{{ item.mid }}</td>
                  <td class="text-center">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isOffsetBy"
                        disabled
                      />
                    </label>
                  </td>
                  <td class="text-right">{{ item.offSetSell }}</td>
                  <td class="text-right">{{ item.offSetBuy }}</td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Update</span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="defaultprovidermodal">
      <div class="modal-dialog modal-xs">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Default Rate Provider</h4>
                <h6>Please fill all information below.</h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.rateProviderModel.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitRateProvider">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label>Rate Provider</label>
                          <v-select
                            class="v-search-select"
                            :class="{
                              'field-error':
                                isSubmitted && $v.rateProviderModel.providerId.$error,
                            }"
                            placeholder=""
                            label="name"
                            v-model="rateProviderModel.providerId"
                            :options="rateProviders"
                            :clearable="true"
                            :searchable="true"
                            :filterable="true"
                            :reduce="(option) => option.id"
                          ></v-select>
                          <small
                            class="form-text sts-danger"
                            v-if="
                              isSubmitted && !$v.rateProviderModel.providerId.required
                            "
                            >Provider is required</small
                          >
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" role="dialog" ref="exchangeratemodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new update">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  Data Exchange Rate <span class="text-edited" v-if="isUpdate"></span>
                </h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.rateModel.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submitRateItem">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="form-group" v-if="!isFixer">
                          <label class="required">Sell</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.rateModel.sell.$error,
                            }"
                            type="number"
                            v-model="rateModel.sell"
                            step="any"
                          />
                          <div v-if="isSubmitted && $v.rateModel.sell.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.sell.required"
                              >Sell is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.sell.minValue"
                              >Min sell is
                              {{ $v.rateModel.sell.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group" v-if="!isFixer">
                          <label class="required">Buy</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.rateModel.buy.$error,
                            }"
                            type="number"
                            v-model="rateModel.buy"
                            step="any"
                          />
                          <div v-if="isSubmitted && $v.rateModel.buy.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.buy.required"
                              >Buy is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.buy.minValue"
                              >Min buy is
                              {{ $v.rateModel.buy.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Offset Sell</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error':
                                isSubmitted && $v.rateModel.offSetSell.$error,
                            }"
                            type="number"
                            v-model="rateModel.offSetSell"
                            step="any"
                          />
                          <div v-if="isSubmitted && $v.rateModel.offSetSell.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.offSetSell.required"
                              >OffSetSell is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.offSetSell.minValue"
                              >Min offSetSell is
                              {{ $v.rateModel.offSetSell.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <label class="required">Offset Buy</label>
                          <input
                            class="form-control"
                            :class="{
                              'field-error': isSubmitted && $v.rateModel.offSetBuy.$error,
                            }"
                            type="number"
                            v-model="rateModel.offSetBuy"
                            step="any"
                          />
                          <div v-if="isSubmitted && $v.rateModel.offSetBuy.$error">
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.offSetBuy.required"
                              >OffSetBuy is required</small
                            >
                            <small
                              class="form-text sts-danger"
                              v-if="!$v.rateModel.offSetBuy.minValue"
                              >Min offSetBuy is
                              {{ $v.rateModel.offSetBuy.$params.minValue.min }}</small
                            >
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="btn-group-checkbox">
                            <div class="checkbox">
                              <label>
                                <input
                                  type="checkbox"
                                  :value="rateModel.isOffsetBy"
                                  v-model="rateModel.isOffsetBy"
                                />
                                Percentage
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">Save Changes</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import exchangeRateService from "@/services/master/exchangeRate/exchangeRateService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return (
        this.allPermissions.includes("CreateMapping") ||
        this.allPermissions.includes("UpdateMapping")
      );
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    baseCurrency: function () {
      return this.items !== undefined && this.items !== null && this.items.length > 0
        ? this.items[0].baseCurrency
        : "";
    },
  },
  data() {
    return {
      isSubmitted: false,
      isUpdate: false,
      allPermissions: [],
      isMapped: null,
      isFixer: null,
      defaultProvider: {},
      filteredProvider: null,
      itemToBeDeleted: null,
      items: [],
      rateProviders: [],
      rateProviderModel: {},
      rateModel: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      rateProviderModel: {
        providerId: { required },
      },
      rateModel: {
        buy: { required, minValue: minValue(0) },
        sell: { required, minValue: minValue(0) },
        offSetBuy: { required, minValue: minValue(0) },
        offSetSell: { required, minValue: minValue(0) },
        isOffsetBy: { required, minValue: minValue(0) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getMapping();
      await this.getAllProviders();
      if (this.defaultProvider && this.defaultProvider.providerId) {
        const provider = this.rateProviders.find(
          (x) => x.id === this.defaultProvider.providerId
        );
        this.isFixer = provider.name.toLowerCase() === "fixer";
        this.filteredProvider = provider.id;
        this.getAll(this.defaultProvider.providerId);
      } else {
        this.isFixer = this.rateProviders[0].name.toLowerCase() === "fixer";
        this.filteredProvider = this.rateProviders[0].id;
        this.getAll(filteredProvider);
      }
    }
  },
  mounted() {
    $(this.$refs.exchangeratemodal).on("hidden.bs.modal", this.closeRateModal);
    $(this.$refs.defaultprovidermodal).on("hidden.bs.modal", this.closeProviderModal);
  },
  updated() {
    this.$helper.collapseMenu("administration");
    this.$helper.setNavigationClass("exchange-rate-link");
  },
  methods: {
    async onClickRateProvider(item) {
      if (item.id === this.filteredProvider) {
        return;
      }
      try {
        this.isLoading = true;
        this.filteredProvider = item.id;
        this.isFixer = item.name.toLowerCase() === "fixer";
        await this.getAll(this.filteredProvider);
      } finally {
        this.isLoading = false;
      }
    },
    resetModel() {
      this.rateProviderModel = {};
      this.rateModel = {};
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.rateProviderModel.$reset();
      this.$v.rateModel.$reset();
    },
    openRateModal(object) {
      this.resetValidations();
      this.rateModel = Object.assign({}, object);
      $(this.$refs.exchangeratemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeRateModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.exchangeratemodal).modal("hide");
    },
    updateItem(item) {
      this.openRateModal(item);
    },
    async getAllProviders() {
      this.rateProviders = await exchangeRateService.getAllProviders();
    },
    async getMapping() {
      try {
        this.isLoading = true;
        const response = await exchangeRateService.getMapping();
        this.isMapped = true;
        this.defaultProvider = response;
      } catch (error) {
        this.isMapped = false;
      } finally {
        this.isLoading = false;
      }
    },
    async getAll(providerRate) {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        this.items = await exchangeRateService.getAll(providerRate);
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submitRateItem() {
      this.isSubmitted = true;
      this.$v.rateModel.$touch();
      if (this.$v.rateModel.$error) {
        return;
      }
      const isUpdate = !!this.rateModel.id;
      try {
        this.isLoading = true;
        this.rateModel.sell = parseFloat(this.rateModel.sell);
        this.rateModel.buy = parseFloat(this.rateModel.buy);
        this.rateModel.mid = parseFloat(this.rateModel.mid);
        this.rateModel.offSetSell = parseFloat(this.rateModel.offSetSell);
        this.rateModel.offSetBuy = parseFloat(this.rateModel.offSetBuy);
        await exchangeRateService.updateRate(this.rateModel);
        this.$notification.success("Successfully updated.", { title: "Success" });
        await this.getAll(this.filteredProvider);
        this.closeRateModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async createProvider() {
      await this.getMapping();
      this.resetModel();
      this.resetValidations();
      this.rateProviderModel = Object.assign(
        {},
        { providerId: this.defaultProvider.providerId }
      );
      $(this.$refs.defaultprovidermodal).modal({ backdrop: "static", keyboard: false });
    },
    closeProviderModal() {
      this.resetModel();
      this.resetValidations();
      this.rateProviderModel.providerId = null;
      $(this.$refs.defaultprovidermodal).modal("hide");
    },
    async submitRateProvider(item) {
      this.isSubmitted = true;
      this.$v.rateProviderModel.$touch();
      if (this.$v.rateProviderModel.$error) {
        return;
      }
      try {
        this.isLoading = true;
        const isUpdate = !!this.rateProviderModel.id;
        if (this.isMapped) {
          this.rateProviderModel.id = this.defaultProvider.id;
          this.rateProviderModel.clientId = this.defaultProvider.clientId;
          this.rateProviderModel.supplierId = this.defaultProvider.supplierId;
          await exchangeRateService.updateMapping(this.rateProviderModel);
          this.$notification.success("Successfully updated.", { title: "Success" });
        } else {
          await exchangeRateService.createMapping(this.rateProviderModel);
          this.$notification.success("Successfully created.", { title: "Success" });
        }
        this.closeProviderModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/exchangeRate/ExchangeRate.vue